module.exports={Remove:"Quitar"};